/**
 * Widget date presets — stored as date_range; resolved to date_from / date_to for APIs.
 */
export type WidgetDateRange = 'today' | 'week';

export const WIDGET_DATE_RANGE_OPTIONS: { value: WidgetDateRange; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
];

export function resolveWidgetDateRange(range?: WidgetDateRange | string): { date_from: string; date_to: string } {
  const end = new Date();
  const dateTo = end.toISOString().slice(0, 10);
  if (range === 'week') {
    const start = new Date(end);
    start.setUTCDate(start.getUTCDate() - 6);
    return { date_from: start.toISOString().slice(0, 10), date_to: dateTo };
  }
  return { date_from: dateTo, date_to: dateTo };
}
